export default {
  courseList: state => state.courseList,
  lastDayVideoCount: state => state.lastDayVideoCount,
  lastDayExamCount: state => state.lastDayExamCount
}
